import React from 'react';

import { useTranslation } from 'next-i18next';

import type { TagProps } from 'src/components/ui/Tag';
import Tag from 'src/components/ui/Tag';
import getPriceEvaluation from 'src/utils/getPriceEvaluation';
import { colours } from 'src/constants/colours';
import { styledComponent } from 'src/utils/styled';

interface Props {
    price: number;
    confidenceMin: number;
    confidenceMax: number;
    size?: TagProps['size'];
    dataTestIdPrefix?: string;
}

const StyledTag = styledComponent(Tag)`
    color: ${colours.success.main};
    background-color: ${colours.successOpaque.O12};
`;

const PriceEvaluationTag: React.FC<Props> = ({ price, confidenceMin, confidenceMax, size, dataTestIdPrefix }) => {
    const { t } = useTranslation(['ad']);
    const evaluation = getPriceEvaluation(price, confidenceMin, confidenceMax);

    // Expensive, show nothing
    if (evaluation === 'expensive') {
        return null;
    }

    const dataTestIdPrefixWithDash = dataTestIdPrefix ? `${dataTestIdPrefix}-` : '';

    // Very good
    if (evaluation === 'veryGood') {
        return (
            <StyledTag
                label={t('ad:veryGoodPrice')}
                size={size}
                data-target-id={`${dataTestIdPrefixWithDash}tag-very-good-price`}
                color="success"
            />
        );
    }

    // Good
    return (
        <StyledTag
            size={size}
            label={t('ad:goodPrice')}
            data-target-id={`${dataTestIdPrefixWithDash}tag-good-price`}
            color="success"
        />
    );
};

export default PriceEvaluationTag;
